import React from "react";
import { Search, UserCheck, FileCheck, KeyRound, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import "./HowItWorks.css";

const STEPS = [
  {
    step: "01",
    icon: Search,
    title: "Find Your Property",
    text: "Explore thousands of verified residential and commercial properties across India with high-res photos and transparent pricing.",
  },
  {
    step: "02",
    icon: UserCheck,
    title: "Meet Our Property Expert",
    text: "Schedule visits and get dedicated assistance from verified property specialists who understand your exact neighborhood and budget.",
  },
  {
    step: "03",
    icon: FileCheck,
    title: "Seamless Verification",
    text: "Enjoy peace of mind with legal title checks, loan assistance, and streamlined paperwork managed digitally by our team.",
  },
  {
    step: "04",
    icon: KeyRound,
    title: "Receive the Keys",
    text: "Complete hassle-free registration, step into your dream property, and begin your next chapter with zero stress.",
  },
];

const HowItWorks = () => (
  <section className="hiw">
    <div className="hiw__container">
      <div className="hiw__header">
        <span className="hiw__label">How It Works</span>
        <h2 className="hiw__title">
          Find Your Dream Property in <em>4 Simple Steps</em>
        </h2>
        <p className="hiw__subtitle">
          From browsing verified listings to receiving your keys, we ensure complete transparency and convenience.
        </p>
      </div>

      <div className="hiw__grid">
        {STEPS.map(({ step, icon: Icon, title, text }, i) => (
          <div key={title} className="hiw__step">
            <div className="hiw__step-top">
              <div className="hiw__step-icon-wrap">
                <Icon size={24} />
              </div>
              <span className="hiw__step-number">{step}</span>
            </div>
            <h3 className="hiw__step-title">{title}</h3>
            <p className="hiw__step-text">{text}</p>
          </div>
        ))}
      </div>

      <div className="hiw__cta-row">
        <Link to="/property-list" className="hiw__cta-btn">
          <span>Start Exploring Listings</span>
          <ArrowRight size={16} strokeWidth={2.5} />
        </Link>
      </div>
    </div>
  </section>
);

export default HowItWorks;